import React from "react";
import { FaEdit, FaEyeSlash } from "react-icons/fa";
import { FaPencil, FaRegEye } from "react-icons/fa6";
import { IoMdTrash, IoIosSend } from "react-icons/io";
import { LuPlus, LuUndo2 } from "react-icons/lu";
import { MdHistory, MdOutlineCancel, MdPrint, MdOutlineRestoreFromTrash } from "react-icons/md";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { HiOutlinePrinter } from "react-icons/hi2";


const EditIcon = ({ iconSize = "16", onClick, className, title = "" }) => {
  return (
    <FaEdit
      size={iconSize}
      className={`text-gray-500 mx-2 cursor-pointer ${className}`}
      onClick={onClick}
      title={title}
    />
  );
};
const DeleteIcon = ({ iconSize = "17", onClick, className, title = "" }) => {
  return (
    <IoMdTrash
      size={iconSize}
      className={`text-red-500 ${className} cursor-pointer`}
      onClick={onClick}
      title={title}
    />
  );
};
const EyeIcon = ({ iconSize = "15", onClick, title = "",className="" }) => {
  return (
    <FaRegEye
      size={iconSize}
      className={`text-primary ${className} cursor-pointer`}
      onClick={onClick}
      title={title}
    />
  );
};
const EyeSlashIcon = ({ iconSize = "15", onClick,className }) => {
  return (
    <FaEyeSlash
      size={iconSize}
      className={`text-blue ${className} cursor-pointer`}
      onClick={onClick}
    />
  );
};
const AddIcon = ({ iconSize = "16", onClick, title = "" }) => {
  return (
    <LuPlus
      size={iconSize}
      className="text-gray-500 cursor-pointer"
      onClick={onClick}
      title={title}
    />
  );
};
const PencilIcon = ({ iconSize = "15", onClick }) => {
  return (
    <FaPencil
      size={iconSize}
      className="text-gray-500 cursor-pointer"
      onClick={onClick}
    />
  );
};

const CancelIcon = ({ iconSize = "15", onClick, title = "" }) => {
  return (
    <MdOutlineCancel
      size={iconSize}
      className="text-red-500 cursor-pointer"
      title={title}
      onClick={onClick}
    />
  );
};

const PrintIcon = ({
  iconSize = "15",
  onClick,
  title = "Print",
  disabled = false,
}) => {
  return (
    <HiOutlinePrinter
      size={iconSize}
      className="text-blue cursor-pointer disabled:text-blue/20"
      title={title}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

const PaymentIcon = ({ iconSize = "16", onClick = () => { }, title = "Payment", className = "" }) => {
  return (
    <LiaFileInvoiceDollarSolid
      size={iconSize}
      className={`text-green-600 cursor-pointer ${className}`}
      title={title}
      onClick={onClick}
    />
  );
};

const SendIcon = ({ iconSize = "20", onClick = () => { }, title = "", className = "" }) => {
  return (
    <IoIosSend
      size={iconSize}
      className={`cursor-pointer ${className}`}
      title={title}
      onClick={onClick}
    />
  );
};

const UndoIcon = ({ iconSize = "16", onClick = () => { }, title = "Undo (Reverse)", className = "" }) => {
  return (
    <LuUndo2
      size={iconSize}
      className={`text-orange-500 cursor-pointer ${className}`}
      title={title}
      onClick={onClick}
    />
  );
};

const RestoreIcon = ({ iconSize = "16", onClick = () => { }, title = "Restore", className = "" }) => {
  return (
    <MdOutlineRestoreFromTrash
      size={iconSize}
      className={`text-green-600 cursor-pointer ${className}`}
      title={title}
      onClick={onClick}
    />
  );
};

const AuditIcon = ({ iconSize = "17", onClick = () => { }, title = "Audit Logs", className = "" }) => {
  return (
    <MdHistory
      size={iconSize}
      className={`text-indigo-600 cursor-pointer ${className}`}
      title={title}
      onClick={onClick}
    />
  );
};

export {
  EditIcon,
  DeleteIcon,
  EyeIcon,
  PencilIcon,
  CancelIcon,
  PrintIcon,
  EyeSlashIcon,
  AddIcon,
  PaymentIcon,
  SendIcon,
  UndoIcon,
  RestoreIcon,
  AuditIcon,
};
